import Page from 'components/Page';
import React, {Component} from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Button
} from 'reactstrap';

import Select from 'react-select';

import {validarItem, validarFormulario} from './../utils/validar'; 
import Confirmar from '../components/ModalConfirmar'; 
import Cargando from './../components/Cargando';
import { FaSave , FaTrashAlt, FaRegEnvelope} from "react-icons/fa";
import Notificaciones from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from 'utils/constants';

import Utils from './../utils/utils';
import u from './../utils/utils'; 
import TablaUsuarios from './../components/TablaUsuarios'; 
import Botonera from './../components/BotoneraGuardar';
import SelectTipoUsuario from './../components/SelectTipoUsuario'; 
import SelectComuna from './../components/SelectComunas'; 
import Usuario from './../api/Usuario'; 
import Correo from './../api/Correo';

const correo = new Correo(); 
const usuario = new Usuario(); 

class GestorUsuarios extends Component {
    constructor() {
        super(); 
        this.state = {
            tipo:'',
            editar:'',
            id:'',
            nombres:'',
            apellidos: '',
            email:'',
            pass:'',
            data:[],
            telefono:'',
            direccion:'',
            comuna:'',
            ocultarPass:true,

            cargando:true,
            validacion:{
                id:         false,
                nombres:    false,
                apellidos:  false,
                email:      false,
                direccion:  false,
                telefono:   false,
                tipo:       false,
                pass:       false,
            },
            confirmarGuardar: false,
            confirmarEditar: false, 
            confirmarBorrar: false,
            idBorrar:'',

            listaRuts:[],
            filtro:'',
            listadoUsuarios:[]
        }
    }

    estadoDefault = () => {
        const {editar, listaRuts} = this.state;
        let lr = editar !== '' ? listaRuts : [];
        this.setState({
            tipo:'',
            editar:'',
            id:'',
            nombres:'',
            apellidos: '',
            email:'',
            pass:'',
            telefono:'',
            direccion:'',
            comuna:'',
            ocultarPass:true,

            validacion:{
                id:         false,
                nombres:    false,
                apellidos:  false,
                email:      false,
                direccion:  false,
                telefono:   false,
                tipo:       false,
                pass:       false,
            },
            confirmarGuardar: false,
            confirmarEditar: false, 
            confirmarBorrar: false,
            idBorrar:'',

            listaRuts:lr,
            filto:'',
            listadoUsuarios:[]
        })
    }


    manejaTipo = (evento) => {
        this.setState({tipo: evento.target.value})
    }

    manejaCambio = (e) => {
		const { name, value } = e.target;
		this.setState({ [name]: value });
    }

    manejaComuna = (value) => {
        this.setState({comuna: value});
    
    }

    cargarListado = async () => {
        let ruts = [];
        let nombreRut = [];
        let listado = await usuario.mostrar(); 

        for (const r in listado) {
            ruts.push(Utils.espacioGuion(listado[r].id)); 
            nombreRut.push({value: Utils.espacioGuion(listado[r].id), label: listado[r].id+' | '+ listado[r].nombres+' '+listado[r].apellidos}); 
        }

        
        this.setState({data: listado, cargando:false, listaRuts: ruts, listadoUsuarios: nombreRut});    
    }




    /* funciones comunes para mensajes y validaciones */ 
    guardarEditarValidando = async ({validacion, confirmar}) =>{
        let validado = await validacion();

        if(validado.resultado){
            confirmar()
        }else{

            for (const k in validado.mensajes) {

                this.Notificaciones.addNotification({
                    message: validado.mensajes[k],
                    level: 'error',
                    position:'tr'
                });
                 
            }
    
        }  

    }

    mensajeGuardadoEditado = async ({resultado, mensaje, icono, tipo}) =>{
        if(resultado==="ok"){

            await this.cargarListado();
            this.estadoDefault();
            
            this.Notificaciones.addNotification({
                title: <FaSave/>,
                message: mensaje,
                level: 'success',
                position:'tr'
            });

        } else{
            this.Notificaciones.addNotification({
                message: 'Error inesperado, intentelo más tarde',
                level: 'error',
                position:'tr'
            });  
        }

        this.setState({cargando:false});   
    }


    validacionFormulario = async () => {
        const { id, pass, nombres, apellidos, email,  tipo, direccion, telefono, listaRuts, editar} = this.state;  

        let vId = editar==='repetido' || editar==='editar' ? validarItem({valor:id, input:'RUT', vacio:true, rut:true, largo:12}) : validarItem({valor:id, input:'RUT', vacio:true, rut:true, largo:12, repetido:{valor:id, arreglo:listaRuts}});  

        let vNombres    = validarItem({valor:nombres, input:'Nombres', vacio:true,  largo:90});
        let vApellidos  = validarItem({valor:apellidos, input:'Apellidos', vacio:true,  largo:90});
        let vEmail      = validarItem({valor:email, input:'Email', vacio:true,  largo:90, email:true});
        let vDireccion  = validarItem({valor:direccion, input:'Dirección', vacio:false,  largo:200});
        let vTelefono   = validarItem({valor:telefono, input:'Telélefono', vacio:false,  largo:20});
        let vTipo       = validarItem({valor:tipo, input:'Tipo de usuario', select:true});
        let vPass       = validarItem({valor:pass, input:'Contraseña', vacio:true,  largo:45});


        if(vId.respuesta.length>0 && vId.respuesta[0].validador==='repetido'){
            this.setState({ editar:'repetido'})
        }
        
        this.setState({ validacion:{
            id:          !vId.resultado, 
            nombres:     !vNombres.resultado, 
            apellidos:   !vApellidos.resultado, 
            email:       !vEmail.resultado, 
            direccion:   !vDireccion.resultado, 
            telefono:    !vTelefono.resultado, 
            tipo:        !vTipo.resultado, 
            pass:        !vPass.resultado
        } });  

        
        let formulario = validarFormulario([vId, vNombres, vApellidos, vEmail, vDireccion, vTelefono, vTipo, vPass]); 

        return formulario;

    }



    /* ingresar */

    muestraConfirmarGuardar = () => {
        this.setState(prevState => ({
            confirmarGuardar: !prevState.confirmarGuardar
        }));    
    }

    ingresarUsuario = async () => {
        this.guardarEditarValidando({
            validacion: this.validacionFormulario,
            confirmar: this.muestraConfirmarGuardar   
        }); 
    }

    ingresarUsuarioBD = async () =>{
        this.setState({cargando:true});

        const { id, pass, nombres, apellidos, email,  tipo, direccion, comuna, telefono} = this.state;  

        let comunaEnviar =  comuna!=='' && comuna!==undefined  && comuna!==null? comuna.value : '';
        let resultado = await usuario.ingresar(id, pass, nombres, apellidos, email, tipo, direccion, comunaEnviar, telefono); 
        
        this.mensajeGuardadoEditado({resultado:resultado, mensaje: 'Usuario ingresado correctamente'});
        if(resultado==="ok"){

            let resultadoEmail = await correo.ingresoUsuario(id, pass, email, nombres, apellidos); 
            if(resultadoEmail==="ok"){

                this.Notificaciones.addNotification({
                    title: <FaRegEnvelope/>,
                    message: 'Se envío un correo con los datos de acceso al usuario creado',
                    level: 'success',
                    position:'tr'
                });
                
            }else {
                this.Notificaciones.addNotification({
                    message: 'Error inesperado',
                    level: 'error',
                    position:'tr'
                });  
            }
        } 

    }


    /* editar */

    muestraConfirmarEditar = () => {
        this.setState(prevState => ({
            confirmarEditar: !prevState.confirmarEditar
        }));    
    }

    editarUsuario = async () => {
        this.guardarEditarValidando({
            validacion: this.validacionFormulario,
            confirmar: this.muestraConfirmarEditar   
        }); 
    }

    editarUsuarioBD = async () =>{
        this.setState({cargando:true});

        const { id, nombres, apellidos, email, pass, tipo,  direccion, comuna, telefono} = this.state;   
        
        let comunaEnviar =  comuna!=='' && comuna!==undefined  && comuna!==null? comuna.value : '';
        let resultado = await usuario.editar( id, pass, nombres, apellidos, email, tipo,  direccion, comunaEnviar, telefono );
        
        this.mensajeGuardadoEditado({resultado:resultado, mensaje: 'Usuario editado correctamente'}) 

    }

    cargarEditar = (u) => {

        const comuna = u.comuna !=='' ? {value: u.comuna, label:u.comuna}: ''; 
        
        this.setState({
            tipo:u.tipoUsuario_id,
            editar:'editar',
            id:u.id,
            nombres:u.nombres,
            apellidos: u.apellidos,
            email:u.email,
            pass:u.password,
            direccion:u.direccion,
            comuna:comuna,
            telefono:u.telefono,
        }) 
    }


    /* borrar */

    muestraConfirmarBorrar = (id) => {
        this.setState((prevState) => ({
            confirmarBorrar: !prevState.confirmarBorrar,
            idBorrar: id
        }));          
    }

    eliminarUsuario = async () => {
        this.setState({cargando:true});
        
        let resultado = await usuario.eliminar(this.state.idBorrar)

        if(resultado==="ok"){
            await this.cargarListado();
            
            this.Notificaciones.addNotification({
                title: <FaTrashAlt/>,
                message: 'Usuario eliminado satisfactoriamente',
                level: 'info',
                position:'tr'
            });
        }else{
            this.Notificaciones.addNotification({
                message: 'Error inesperado, intentelo más tarde',
                level: 'error',
                position:'tr'
            });          
        }

       
        this.setState({cargando:false});
    }


    ocultarMostrar = () => {
        this.setState(prevState => ({
            ocultarPass: !prevState.ocultarPass
        }));    
    }


    generarPass = () => {
        let pass = u.generarPass(8); 
        this.setState({
            ocultarPass:false,
            pass:pass,
        })
        
    }

    manejaUsuario = (value) => {
        this.setState({filtro: value});
    
      }
    componentDidMount(){
        this.cargarListado();
    }

    render() {
        const {tipo, id, nombres, apellidos, email, pass, data, editar, telefono, direccion, comuna, ocultarPass, cargando, confirmarGuardar, confirmarEditar, confirmarBorrar, validacion, filtro, listadoUsuarios} = this.state; 

        return (
            <Page title="Administrador de usuarios" breadcrumbs={[ { name: 'Usuarios', active: true } ]}>
                <Cargando valor={cargando}/>
        
                <Card>
                    <CardHeader>Información del usuario</CardHeader>
                    <CardBody>
                    <Form>
         
                        <Row className="no-margin-bottom">
        
                            <Col  lg={2} md={4} sm={12}>
                                <FormGroup>
                                    <Label>RUT</Label>
                                    <Input
                                        type="text"
                                        name="id"
                                        value={id}
                                        placeholder="12345678-9"
                                        onChange={this.manejaCambio}
                                        invalid={validacion.id}
                                        maxLength={12}
                                        disabled={editar==='editar' || editar==='repetido'}
                                    />
                                </FormGroup>
                            </Col>
                            <Col  lg={3} md={4} sm={12}>
                                <FormGroup>
                                    <Label>Nombres</Label>
                                    <Input
                                        type="text"
                                        name="nombres"
                                        value={nombres}
                                        onChange={this.manejaCambio}
                                        invalid={validacion.nombres}
                                        maxLength={90}
                                    />
                                </FormGroup>
                            </Col>
                            <Col  lg={3} md={4} sm={12}>
                                <FormGroup>
                                    <Label>Apellidos</Label>
                                    <Input
                                        type="text"
                                        name="apellidos"
                                        value={apellidos}
                                        onChange={this.manejaCambio}
                                        invalid={validacion.apellidos}
                                        maxLength={90}
                                    />
                                </FormGroup>
                            </Col>
                            <Col  lg={4} md={4} sm={12}>
                                <FormGroup>
                                    <Label>Email</Label>
                                    <Input
                                        type="text"
                                        name="email"
                                        value={email}
                                        onChange={this.manejaCambio}
                                        invalid={validacion.email}
                                        maxLength={90}
                                    />
                                </FormGroup>
                            </Col>
        

        
                            <Col  lg={4} md={4} sm={12}>
                                <FormGroup>
                                    <Label>Dirección</Label>
                                    <Input
                                        type="text"
                                        name="direccion"
                                        value={direccion}
                                        onChange={this.manejaCambio}
                                        invalid={validacion.direccion}
                                        maxLength={200}
                                    />
                                </FormGroup>
                            </Col>
        
                            <Col  lg={3} md={4} sm={12}>
                                <FormGroup>
                                    <Label>Comuna</Label>
                                    <SelectComuna maneja={this.manejaComuna} comuna={comuna}/>
                                </FormGroup>
                            </Col>
        
                            <Col  lg={2} md={4} sm={12}>
                                <FormGroup>
                                    <Label>Teléfono</Label>
                                    <Input
                                        type="text"
                                        name="telefono"
                                        value={telefono}
                                        onChange={this.manejaCambio}
                                        invalid={validacion.telefono}
                                        maxLength={20}
                                    />
                                </FormGroup>
                            </Col>

                            <Col  lg={2} md={4} sm={12}>
                                <FormGroup>
                                    <Label >Tipo de usuario</Label>
                                    <SelectTipoUsuario 
                                        maneja={this.manejaTipo}
                                        tipo={tipo}
                                        invalido={validacion.tipo}
                                    />
                                </FormGroup>
                            </Col>

                            <Col  lg={2} md={4} sm={12}>
                                <FormGroup>
                                    <Label>
                                        Contraseña
                                        <Button color="secondary" size="sm"  className="btn-label" onClick={()=>this.ocultarMostrar()}>
                                            {ocultarPass ? "Mostrar" : "Ocultar"}
                                        </Button>
                                    </Label>
                                    <Input
                                        type={ocultarPass ? "password" : "text"}
                                        name="pass"
                                        value={pass}
                                        onChange={this.manejaCambio}
                                        invalid={validacion.pass}
                                        maxLength={45}
                                    />
                                </FormGroup>
                            </Col>

                            <Col  lg={3} md={4} sm={12}>
                                <FormGroup>
                                <Button color="primary" size="sm" className="btn-cuerpo" onClick={this.generarPass}>
                                    Generar contraseña
                                </Button>
                                </FormGroup>
                            </Col>
        

        
        
        
                        </Row>
              
                    </Form>
                    </CardBody>
                    <Botonera 
                        valor={editar}
                        ingresar={this.ingresarUsuario}
                        editar={this.editarUsuario}
                        cancelar={this.estadoDefault}
                    />



                </Card>
        
        
                <br/>
                <Row>
                    <Col sm={12} lg={{ size: 4, offset: 8 }} md={{ size: 6, offset: 6 }} >
                        <Select 
                        value={filtro} 
                        onChange={this.manejaUsuario}
                        isClearable={true} 
                        options={listadoUsuarios} 
                        placeholder="RUT o Nombre"  
                        noOptionsMessage={() => "No se encontraron resultados"}
                        /> 
                    </Col>
                </Row>

        
                <TablaUsuarios
                    data= {data}
                    eliminar = {this.muestraConfirmarBorrar}
                    editar = {this.cargarEditar}
                    filtro={filtro}
                /> 
        


                <Confirmar 
                    isOpen={confirmarGuardar} 
                    toggle={this.muestraConfirmarGuardar} 
                    texto={"¿Esta seguro de guardar el usuario?"} 
                    funcion={this.ingresarUsuarioBD} 
                />

                 <Confirmar 
                    isOpen={confirmarEditar} 
                    toggle={this.muestraConfirmarEditar} 
                    texto={"¿Esta seguro de editar el usuario?"} 
                    funcion={this.editarUsuarioBD} 
                />

                 <Confirmar 
                    isOpen={confirmarBorrar} 
                    toggle={this.muestraConfirmarBorrar} 
                    texto={"¿Esta seguro de borrar al usuario?"} 
                    funcion={this.eliminarUsuario} 
                />


                <Notificaciones
                    dismissible={false}
                    ref={Notificaciones =>
                        (this.Notificaciones = Notificaciones)
                    }
                    style={NOTIFICATION_SYSTEM_STYLE}
                    />
        
            </Page>
        );  
    }
  
};

export default GestorUsuarios;
